<div class="state-indicator-cell">
  @if (state) {
    <app-ui-state-indicator [state]="state" [stateToIconMapping]="stateToIconMapping" [stateToClassMapping]="stateToClassMapping"></app-ui-state-indicator>
  }
  @if (text) {
    <span class="state-text">{{ text }}</span>
  }
</div>
